export default "/assets/images/chart-sm-01.svg?386def8e225e1f3867d700c7dff0b390";